import React from 'react';
import Head from 'next/head';
import { useQuery } from '@apollo/client';
import { Loading } from '@avila-tek/ui/src';
import { GET_ALL_CATEGORIES_WITH_ALLIES } from '../../graphql/queries';
import { Category, Company } from '../../models';
import Layout from '../../components/layout/Layout';
import SectionsCatalog from '../../components/sections/SectionsCatalog';
import FadeAnimation from '../../components/FadeAnimation/FadeAnimation';

function SectionsPage() {
  const {
    data: dataGetAllCategoriesWithAllies,
    loading: loadingGetAllCategoriesWithAllies,
  } = useQuery<{
    getAllCategoriesWithAllies: { allies: Company[]; category: Category }[];
  }>(GET_ALL_CATEGORIES_WITH_ALLIES, {
    fetchPolicy: 'network-only',
  });

  return (
    <>
      <Head>
        <title>Meit | Catálogo</title>
      </Head>
      <Layout lowMargin>
        {loadingGetAllCategoriesWithAllies ? (
          <Loading />
        ) : (
          <FadeAnimation>
            <SectionsCatalog
              sections={
                dataGetAllCategoriesWithAllies?.getAllCategoriesWithAllies
              }
            />
          </FadeAnimation>
        )}
      </Layout>
    </>
  );
}

SectionsPage.auth = true;

export default SectionsPage;
